export var TIMEOUT_PASSED = 1;
export var TIMEOUT_FUTURE = 2;
export var TIMEOUT_SOON = 4;
export var TIMEOUT_URGENT = 8;
export var getTomorrowMidnight = function getTomorrowMidnight() {
  var d = new Date();
  d.setHours(23);
  d.setMinutes(59);
  d.setSeconds(59);
  d.setMilliseconds(999);
  d.setDate(d.getDate() + 1);
  return d;
};

/**
 * @param {Date|string} date
 * @return {[
 *  number,
 *  string | null
 * ]}
 */
export var getTimeoutDisplay = function getTimeoutDisplay() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (date === null) {
    return [null, null];
  }
  if (typeof date === "string") {
    var ts = Date.parse(date);
    if (isNaN(ts)) {
      return [null, null];
    }
    date = new Date(ts);
  }
  var now = new Date();
  var tomorrowMidnight = getTomorrowMidnight();
  var isTomorrow = date.getDate() === now.getDate() + 1;

  /** type  */
  var bit = 0;
  if (date < now) {
    return [TIMEOUT_PASSED, "Bereits ausgelaufen 🙁"];
  } else {
    bit = TIMEOUT_FUTURE;
  }
  if (date > tomorrowMidnight) {
    return [bit, "Bis ".concat(date.toLocaleDateString("de-DE"))];
  }
  bit += TIMEOUT_SOON;
  if (!isTomorrow) {
    bit += TIMEOUT_URGENT;
  }
  return [bit, "Bis ".concat(isTomorrow ? "morgen" : "heute", " ").concat(date.toLocaleTimeString("de-DE"))];
};
export var toEuro = function toEuro(val) {
  return "€" + Number(val).toLocaleString("de-DE", {
    minimumFractionDigits: 2
  });
};
//# sourceMappingURL=Offer.js.map